import React, { useEffect, useRef } from 'react';
/** lib **/
import { useScrollToAnchor } from 'lib/use-scroll-anker-link';
/** components **/
import {
  KeyVisual,
  TopNews,
  WhatIsPman,
  IssuesInPetOwnership,
  Friends,
  AreaFloorPlanRent,
  OurPartner,
  TopSupporterVoice,
  Layout,
  TopComics,
  VoteSectionBanner,
  ClosingNoticeBox,
} from 'components/organisms';
/** styles **/
import s from '../styles/pages/top.module.scss';

export const Top: React.FC = () => {
  const { scrollToAnchor } = useScrollToAnchor({ smooth: true });
  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const animationEl = [inViewRef1];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(s.inview);
          } else {
            entry.target.classList.remove(s.inview);
          }
        });
      },
      {
        root: null,
        rootMargin: '-90% 0px 20% 0px',
        threshold: 0,
      },
    );
    animationEl.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      animationEl.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [animationEl]);

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: '/',
      });
    }
  }, []);

  useEffect(() => {
    scrollToAnchor();
  }, [scrollToAnchor]);


  return (
    <Layout hideClosingBar>
      <div id="top" className={s.topWrapper}>
        <div className={s.kv} ref={inViewRef1}>
          <KeyVisual />
        </div>
        <div className={s.closingSection}>
          <ClosingNoticeBox />
        </div>
        <div id="news">
          <TopNews />
        </div>
        <WhatIsPman />
        <div id="issue">
          <IssuesInPetOwnership />
        </div>
        <TopComics />
        <div id="friends">
          <Friends />
        </div>
        <div id="supporter-voice">
          <TopSupporterVoice />
        </div>
        <div id="area">
          <AreaFloorPlanRent />
        </div>
        <VoteSectionBanner />
        <div id="partner">
          <OurPartner />
        </div>
      </div>
    </Layout>
  );
};
